import { render } from "./App.vue?vue&type=template&id=1b4f1078"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1b4f1078&lang=scss"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__